import React from 'react';
import Card from '../../../../components/Card/Card';
import { injectIntl, FormattedMessage } from 'react-intl';
import { connect } from 'react-redux';
import { STATIC_PATH } from '../../../../config';
import { number } from 'prop-types';


const propTypes = {
    coins: number.isRequired
}

const defaultProps = {
    coins: 0
}

const CoinsWidget = ({ coins }) => {
    return (
        <Card className='simple-widget-3'>
            <Card.Body className='simple-widget-info'>
                <FormattedMessage id='widgets.coins.title' />
                <span><b>{coins}</b></span>
                <img src={`${STATIC_PATH}/img/coin-widget-icon.svg`} alt="Монеты" />
            </Card.Body>
        </Card>
    )
}

CoinsWidget.propTypes = propTypes;
CoinsWidget.defaultProps = defaultProps;

const mapStateToProps = state => ({
    coins: state.webmaster.profile.store.coins,
});

export default connect(mapStateToProps)(injectIntl(CoinsWidget));

